import { z } from 'zod/v4';

export const CUSTOM_VARIABLE_TYPES = ['string', 'number', 'date', 'boolean'] as const;

export type CustomVariableTypes = (typeof CUSTOM_VARIABLE_TYPES)[number];

export const CustomVariableTypesSchema = z.enum([...CUSTOM_VARIABLE_TYPES]);
